import React from 'react'
import ReactDOM from 'react-dom'
import { withSuspenseWrapper } from '../SuspenseWrapper'

// const WrapperApp = withSuspenseWrapper(React.lazy(() => import('./App')))
import WrapperApp from './App'

document.addEventListener('DOMContentLoaded', () => {
    const hasRendered = document.getElementsByClassName('inner-app').length > 0
    if (!hasRendered && location?.pathname?.includes('/app/static_data_manager')) {
        document.title = 'Static Data Manager APP'
        ReactDOM.render(<WrapperApp />, document.getElementById('main-content'))
    }
})
